import {
  GrabIconButton,
  Typography,
  DeleteIconButton,
  Box,
  DELETE_WARNING,
  Grid,
  RichTextReader,
  RichTextEditor,
} from "@compass/core";
import { FormSubQuestion } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import { Input } from "components";
import { Draggable } from "react-beautiful-dnd";

type SurveyQuestionSubQuestionProps = {
  subQuestion: FormSubQuestion;
  index: number;
  selected: boolean | undefined;
  branchedFromSubQuestionId: number | undefined;
  addSubQuestion?: () => void;
  updateSubQuestion?: (value: FormSubQuestion) => void;
};

export const SurveyQuestionSubQuestionDouble = ({
  subQuestion,
  index,
  selected,
  branchedFromSubQuestionId,
  addSubQuestion,
  updateSubQuestion,
}: SurveyQuestionSubQuestionProps) => {
  const [formSubQuestion, setFormSubQuestion] = useState<FormSubQuestion | undefined>(subQuestion);
  const [isHovered, setIsHovered] = useState<boolean>(false);

  useEffect(() => {
    if (updateSubQuestion) updateSubQuestion(formSubQuestion!);
  }, [formSubQuestion]);

  const deleteSubQuestion = (e) => {
    if (window.confirm(DELETE_WARNING)) {
      e.stopPropagation();
      setFormSubQuestion(
        produce((draft) => {
          draft!.deleted = true;
        })
      );
    }
  };

  const grid = 8;

  return (
    <Grid container spacing="sm">
      <Grid item xs={2}>
        {!branchedFromSubQuestionId && (
          <Box>
            {!selected && <Typography>{formSubQuestion?.label}</Typography>}
            {selected && (
              <Input
                placeholder="Add Label"
                value={formSubQuestion?.label}
                onChange={(e) =>
                  setFormSubQuestion(
                    produce((draft) => {
                      draft!.label = e.target.value!;
                    })
                  )
                }
              />
            )}
          </Box>
        )}
      </Grid>
      <Grid item xs={8}>
        <Box style={{ minWidth: 300 }}>
          {!selected && <RichTextReader html={formSubQuestion?.name} />}
          {selected && (
            <RichTextEditor
              justStyle
              placeholder="Add Sub-Question Answer"
              value={formSubQuestion?.name}
              onChange={(value) =>
                setFormSubQuestion(
                  produce((draft) => {
                    draft!.name = value!;
                  })
                )
              }
            />
          )}
        </Box>
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
};
